export default __webpack_public_path__ + "d6e115b.png";